import { type SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { renderRichText } from "@/components/bloks/utils";
import { Prose } from "@/components/ui/Prose";
import {
	AccordionSection,
	type AccordionSectionAlignment,
	type AccordionSectionGroup,
} from "@/components/ui/sections/AccordionSection";
import type { AccordionSectionStoryblok } from "@/generated/sb/sb-types";
import { checkBlokBackground } from "@/lib/utils/isDarkMode";

export const AccordionSectionBlok = ({ blok }: BlokProps<AccordionSectionStoryblok>) => {
	const alignment = (blok.alignment as AccordionSectionAlignment) || "center";
	const bg = checkBlokBackground(blok);

	const groups: AccordionSectionGroup[] = (blok.groups ?? []).map((group) => ({
		id: group._uid,
		title: group.title,
		items: (group.items ?? [])
			.filter((item) => typeof item !== "string")
			.map((item) => ({
				id: item.uuid,
				title: item.content.question ?? "",
				content: <Prose>{renderRichText(item.content.answer)}</Prose>,
			})),
		wrapperProps: storyblokEditable(group as unknown as SbBlokData),
	}));

	return (
		<BlokWrap editable={blok}>
			<AccordionSection
				heading={blok.heading || undefined}
				groups={groups}
				alignment={alignment}
				bg={bg}
			/>
		</BlokWrap>
	);
};
